/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import NodeCollection from '../Utility/Component/ComponentReference/NodeCollection';
import ComponentBase from '../Utility/ComponentBase';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import { CultureID } from './CultureID';
import LocalizationComponent from './LocalizationComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** [[Local]] abstract handler. */
@cc._decorator.ccclass
export default abstract class LocalActionBase extends ComponentBase
{
    @property(InjectableComponent)
    protected nodeCollection: InjectableComponent<NodeCollection> = new InjectableComponent();

    /** @hidden */
    protected localRef: InjectableComponent<LocalizationComponent> = new InjectableComponent();

    /** @hidden */
    protected setContexts(): void
    {
        super.setContexts();
        this.localRef.SetContext(LocalizationComponent);
        this.nodeCollection.SetContext(NodeCollection);
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        if (!this.localRef.HasValue())
        {
            CLog.error('LocalizationComponent failed to inject.', this, LogTypes.Initialization);
            return;
        }

        this.localRef.Value.OnChanged(() => this.onCultureChanged(this.localRef.Value.Value));
    }

    /** @hidden */
    protected abstract onCultureChanged(cultureId: CultureID): void;
}
